export default "__VITE_ASSET__BjKVyk8r__"